export function makeGreen() {
    return `rgb(0, ${Math.floor(Math.random() * 156 + 100)}, 0)`
}